<!-- 直播详情 -->
<template>
  <div>
    <el-alert
      :closable="false"
      type="warning"
      class="v-alert-warning text-center v-browser"
      show-icon>
      <template slot="title">
        {{$t('login2s.browser1')}}
        <span @click="goGoogle()">{{$t('login2s.browser2')}}</span>
        {{$t('login2s.browser3')}}
        <span @click="goIe()">{{$t('login2s.browser4')}}</span>
        {{$t('login2s.browser5')}}
      </template>
    </el-alert>
    <div class="v-live-detail-wrap flex">
      
      <div class="v-live-left">
        <div class="v-live-header flex font-size-18">
          <div class="v-live-header-Title">{{ obj.liveName }}</div>
          <div>{{ $t('lives.startTime') }}：{{obj.liveStartDate | formatDate('all')}}</div>
        </div>
        <div class="v-live-body">
          <v-live-video :vData="obj" :isShowDanMuMoudlue="isShowDanMuMoudlue" :key="random" @callback="callback" :sendStatus="sendStatus"></v-live-video>
        </div>
        <div class="v-live-footer">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="6">
              <div class="font-size-18" v-if="obj.liveState == 1">{{ obj.liveWantCount }} {{ $t('lives.miss') }}</div>
              <div class="font-size-18" v-if="obj.liveState != 1">{{ obj.liveLikeCount }} {{ $t('like') }}</div>
            </el-col>
            <el-col :span="4" v-if="subjectType != 'ACTOR' && isLogin">
              <div @click="goExchange(obj)" class="theme-color font-size-16 pointer exchange">{{ $t('lives.exchangeCards') }}</div>
            </el-col>
          </el-row>

          <v-swiper :option="swiperOption">
            <div class="img-box v-header-img" slot-scope="{ slideData }" slot="swiper-slide">
              <img :src="slideData.userImg ? slideData.userImg : defImage('head')" alt="" />
            </div>
          </v-swiper>
          <div class="v-company-name font-size-18 margin-t-12 f-w-b">{{ obj.liveSponsorName }}</div>
          <div class="margin-tb-12 font-size-18">{{ $t('lives.liveDescribe') }}</div>
          <div class="v-detail font-size-16 p">{{ obj.liveDesc }}</div>
        </div>
      </div>
      <div class="v-live-right" v-if="subjectType == 'VISITOR'">
        <div>
          <v-swiper :option="option1" class="v-vertical-swiper" :showBtn="false">
            <div slot="swiper-slide" slot-scope="{ slideData }" class="v-img pointer">
              <img :src="slideData.icon" alt="" @click="pageDetail(slideData, 'product')" />
            </div>
          </v-swiper>
        </div>

        <div class="theme-color font-size-16 pointer" @click="pageDetail(obj, 'actor')">
          {{ $t('exhibitorInfo') }}
        </div>
      </div>
    </div>
    <!-- 展品列表 -->
    <div class="i-exhibit-list flex-start">
      <div v-for="(item, index) in dataList" :key="item.id" class="i-exhibit-box">
        <ExhibitCard @callback="vExibitsCallback" :vData="item" :index="index" />
      </div>
    </div>
    <div class="i-max-width">
      <el-pagination
        v-if="dataList.length > 0"
        background
        @current-change="handleCurrentChange"
        :page-size="kQuery.pageRows"
        :current-page.sync="kQuery.pageNum"
        layout="total, prev, pager, next, jumper"
        :total="kQuery.total"
        class="bl-page"
      >
      </el-pagination>
    </div>
    
    <!-- 私密直播/需要邀约 弹框 -->
    <div class="liveTipsDialog">
      <el-dialog
        :visible.sync="dialogVisible"
        width="700px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false">
        <div slot="title" class="header-title">
          <div v-if="dialogType == 1">
            <p class="dialogTips font-size-18">{{ $t('Watch the live stream.') }}</p>
            <p class="dialogTips font-size-12">{{ $t('You need to invite exhibitors, or use the invitation code to watch the live broadcast') }}</p>
          </div>
          <div v-else-if="dialogType == 2">
            <p class="dialogTips font-size-18">{{ $t('Private live broadcasting') }}</p>
          </div>
        </div>
        <div class="dialogConcant" v-if="dialogType == 1">
          <p>{{ $t('To watch the live broadcast, please invite the exhibitor immediately or enter the invitation code to watch.') }}<el-button size="mini" @click="goInvitation()">{{ $t('Invite now') }}</el-button></p>
          <div class="dialogConcantDiv" v-if="isLogin">
            <p>{{ $t('Or, enter the invitation code and watch') }}</p>
            <el-input v-model="inviteCode" maxlength="10" size="mini" :placeholder="$t('Please enter the invitation code')"></el-input><el-button  type="primary" size="mini" @click="addInviteCode(obj.liveSponsorId)">{{ $t('determine') }}</el-button>
            <p class="dialogConcantP" @click="message_a(obj)">{{ $t('Contact exhibitors via IM to get the invitation code') }}</p>
          </div>
        </div>
        <div class="dialogConcant" v-else-if="dialogType == 2">
          <div class="dialogConcantDiv">
            <el-input v-model="password" maxlength="10" size="mini" :placeholder="$t('Please enter your password')"></el-input><el-button  type="primary" size="mini" @click="getLivePassword(obj.id)">{{ $t('determine') }}</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <ChatWithExhibitor @invite="submitInvite" :action="action" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { loadLiveDetail, thumbUp, wantLive, checkLiveState, addVisitingCard, validLivePassword } from '@/api/live'
import { addContactPersonByInviteCode } from '@/api/index'
import { fetchLiveProduct } from '@/api/find'
import vSwiper from '@/components/vSwiper'
import ExhibitCard from '@/components/card/ExhibitCard'
import vLiveVideo from '@/components/live/vLiveVideo'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import { eventMixin } from '@/mixins/event.js'
import { 
  // timInit, 
  timLoginAddGrounp, sendImMessage, timQuitGroup } from '@/utils/TIM'

export default {
  name: 'vLiveDetail',
  mixins: [inviteMixin, eventMixin],
  components: {
    vSwiper,
    vLiveVideo,
    ExhibitCard
  },
  computed: {
    ...mapGetters(['isLogin', 'subjectType', 'info', 'language'])
  },
  data() {
    return {
      dialogVisible: false,
      id: this.$route.params.id * 1,
      showTimText:false, //是否显示-TIM评论：目前只有直播显示
      dataList: [], //展品列表
      eId: '', //展商id
      isShowDanMuMoudlue:false, //是否显示冒泡模块
      kQuery: {
        //展品翻页
        pageNum: 1,
        pageRows: 12,
        total: 0
      },
      swiperOption: {
        slidesPerView: 12,
        list: [],
        imgW: '60px',
        height: '60px',
        spaceBetween: 18
      },
      random: Math.random() * 1000000000000000000,
      option1: {
        list: [],
        imgW: '175px',
        direction: 'vertical',
        slidesPerView: 4,
        spaceBetween: 6,
        height: '520'
      },
      TIMStreamNum: '', //房间号
      isJoinLive: false, //是否进入直播间-主播端用
      obj: {}, //直播详情
      password: '', //私密直播密码
      inviteCode: '',//展商邀请码
      dialogType: 1,
      sendStatus: true // 发送弹幕的状态
    }
  },
  created() {
    this.stop = null
    this.loadLiveDetail(res => {
      if (!res.data.data) return
      //展品列表
      this.fetchProductList(res)
      
      let dDate = res.data.data
      this.eId = dDate.liveSponsorId
      this.TIMStreamNum = dDate.streamName
      
      window.PC.$RangersEventDetail(this.id, dDate, 'live')

      if (dDate.liveState == 1) {
        /* 待直播状态 */
        this.startTimeout(dDate.liveStartDate, dDate.liveState)
      } else if (dDate.liveState == 2 && dDate.judgeContact && dDate.scope !== 4) {
        /*  直播状态 */
        this.showTimText = true
        // 显示冒泡模块
        this.isShowDanMuMoudlue = true
        // 加入腾讯IM
        if (this.isLogin) {
          this.addTim()
        }
        this.startTimeout(0, dDate.liveState)
      } else if (dDate.liveState == 3) {
        /* 回放状态 */
        if (!dDate.playBackUrl) {
          this.$alert(this.$t('logins.liveOver'), this.$t('tips')).catch(() => {})
        }
      }
      sessionStorage.setItem('watchType', (dDate.liveState == 3 ? 0 : 1))
    })
  },
  beforeDestroy() {
    this.pageDestroy()
  },
  methods: {
    // 页面消回
    pageDestroy() {
      this.stopTimeOut()
      this.quitTimGroup()
    },
    // 引入腾讯IM
    async addTim() {
      if (!this.isLogin) return
      this.quitTim = true
      // timInit()
      await timLoginAddGrounp({
        userID: this.info.userAccountId,
        groupID: this.TIMStreamNum,
        nick: this.info.name,
        avatar: this.info.headImage
      }).then(() => {
        this.quitTim = false
        sendImMessage('加入腾讯IM', this.TIMStreamNum, '2')
        window.onbeforeunload = () => {
          this.pageDestroy()
        }
        window.onunload = () => {
          this.pageDestroy()
        }
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 退出腾讯IM
    quitTimGroup() {
      if (this.quitTim) return
      let res = timQuitGroup({
        text: '退出腾讯IM', 
        groupID: this.TIMStreamNum
      })
      if (res) {
        res.then(() => {
          this.quitTim = true
        })
      }
    },
    // 发送环信消息
    message_a(data){
      if (!this.isLogin) return
      data.exhibitorId = data.liveSponsorId
      data.atrName = data.liveSponsorName
      this.msgEventExh(data, null, 'exhibitors')
    },
    // 立即邀约，跳转展商详情
    goInvitation() {
      this.dialogVisible = false
      this.pageDetail({id: this.eId}, 'actor', false)
    },
    // 客商 交换名片
    goExchange(obj) {
      addVisitingCard({ userId: obj.anchorId }).then((res) => {
        if (res.data.code == 1000) {
          window.PC.$RangersEventLiveDetail('exchangecards', obj)
          this.$notify({
            title: this.$t('lives.success'),
            message: this.$t('lives.successTips'),
            type: 'success'
          })
        }
      })
    },
    // 页码 change
    handleCurrentChange(page) {
      this.kQuery.pageNum = page
      this.fetchProductList()
    },
    // 展商下产品中心
    fetchProductList() {
      this.searchLoading = true
      fetchLiveProduct({
        id: this.id,
        pageNum: this.kQuery.pageNum,
        pageRows: this.kQuery.pageRows
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            let arr=[];
            let list = res.data.list || []
            for(let i=0;i<list.length;i++){
              let o=res.data.list[i];
              if(o.scope!==1&&o.invite){
                // 客户池可见 邀约 不显示
                o.liveId = this.obj.id
                arr.push(o)
              }
            }
            this.dataList = [...arr];
            this.kQuery.total = res.data.total
          }
        })
        .finally(() => {
          this.searchLoading = false
        })
    },
    // 展品卡片详情
    vExibitsCallback(eData) {
      let d = eData.data
      switch (eData.type) {
        case 'message':
          d = eData.data
          d.atrName = d.exhibitorName
          if (!d.exhibitorId) {
            d.exhibitorId = d.id
          }
          this.msgEventExh(d, null, 'products')
          break
        case 'invite':
          if (eData.data.invite) return
          this.inviteEventExh(eData.data, eData.index, 'products')
          break
        case 'details':
          this.pageDetail(eData.data, 'product')
          break
        case 'collect':
          this.collectEvent({
              id: eData.data.collectionId,
              deleted: eData.data.collected,
              collectionSubjectType: 'PRODUCT',
              collectionSubjectId: eData.data.id,
              liveId: eData.data.liveId
            }, eData.index)
          break
        case 'live':
          break
      }
    },
    // 更新收藏状态
    updateCollect(status, index) {
      this.dataList[index]['collected'] = status
    },
    // 更新邀约状态
    updateInvite(status, index) {
      this.dataList[index]['invite'] = status
    },
    // 直播详情
    loadLiveDetail(fun) {
      let _this = this
      let showDialog = (data) => {
        if (data.scope == 4) {
            if (this.isLogin) {
                this.dialogVisible = true
                this.dialogType = 2
            } else {
                this.isLoginFn()
            }
        } else if (!data.judgeContact) {
            this.dialogType = 1
            this.dialogVisible = true
        }
      }
      loadLiveDetail({ liveId: _this.id }).then(res => {
        if (res.data.code == 1000) {
          _this.obj = res.data.data
          _this.swiperOption.list = res.data.data.wantSeeList
          _this.option1.list = res.data.data.productList
          fun && fun(res)
          if (_this.subjectType == 'ACTOR') {
            if (res.data.data.liveSponsorId != _this.info.exhibitorEmployee.exhibitorId) {
              showDialog(_this.obj)
            } else {
              _this.obj.judgeContact = true
            }
          } else {
            showDialog(_this.obj)
          }
        }
      })
    },
    // 输入邀约码看直播 确定
    addInviteCode(id) {
      if(this.inviteCode !=''){
        addContactPersonByInviteCode({ exhibitorId: String(id), inviteCode: String(this.inviteCode),type: 1 }).then(res => {
          if (res.data.code == 1000 && res.data.data == true) {
            this.dialogVisible = false
            this.obj.judgeContact = true
          } else {
            this.$notify({
              message: this.$t('Invitation code error'),
              type: 'warning'
            })
          }
        })
      } else {
        this.$notify({
          message: this.$t('Please enter the invitation code'),
          type: 'warning'
        });
      }
      
    },
    // 私密直播 确定
    getLivePassword(id) {
      if(this.password != ''){
        validLivePassword({ liveId: String(id), password: String(this.password) }).then(res => {
          if (res.data.data == true) {
            this.dialogVisible = false
            this.obj.judgeContact = true
          } else {
            this.$notify({
              message: this.$t('Password error'),
              type: 'warning'
            })
          }
        })
      } else {
        this.$notify({
          message: this.$t('Please enter your password'),
          type: 'warning'
        })
      }
      
    },
    // 直播卡片 回调事件
    callback(res) {
      if (!this.isLoginFn()) return
      let _this = this
      window.PC.$RangersEventLiveDetail(res.type, res.data)
      if (res.type == 'miss') {
        //想看
        if (res.data.wantLive == 0) {
          wantLive({ liveId: _this.id }).then(res => {
            if (res.data.code == 1000 && res.data.data) {
              _this.obj.liveWantCount = _this.obj.liveWantCount * 1 + 1
              _this.obj.wantLive = 1
            }
          })
        }
      } else if (res.type == 'like') {
        //点赞
        thumbUp({ liveId: _this.id }).then(res => {
            console.log(res)
          if (res.data.code == 1000) {
            _this.obj.liveLikeCount = _this.obj.liveLikeCount * 1 + 1
            // 直播状态中点赞，发送点赞消息
            if (_this.obj.liveState === 2) {
                sendImMessage('点赞', this.TIMStreamNum, '4')
            }
          }
        })
        sendImMessage('点赞', this.TIMStreamNum, '4')
      } else if (res.type=='sendDanMu'){
        // 发送弹幕
        if(!res.data){
          this.$alert(this.$t('lives.sendTextTip'))
          return ''
        }
        
        this.sendStatus = false
        sendImMessage(res.data, this.TIMStreamNum, '1').then(() => {
            this.sendStatus = true
        }).catch(() => {
            this.sendStatus = true
        })
        this.$store.commit('SET_DAN_MU_DATA_PC',res.data)
      }
    },
    // 停止监听 直播状态
    stopTimeOut() {
      if (this.stop) {
        clearTimeout(this.stop)
        this.stop = null
      }
    },
    // 开始监听 直播状态
    startTimeout(startTime, lType) {
      let _this = this
      //定时查看修改状态
      let timeout = 1 * 1000 * 10 //默认10s 查一次
      _this.stopTimeOut() //先删除
      if (startTime) {
        let currTime = new Date().getTime()
        let s = startTime - currTime
        let ts = s - 1000 * 60
        s = ts > 0 ? s/2 : timeout
        timeout = s
      }
      _this.stop = setTimeout(() => {
        checkLiveState({ liveId: _this.id }).then(res => {
          if (res.data.code == 1000) {
            if (res.data.data.liveState == lType) {
              // 状态没有变化-继续查询
              _this.startTimeout(startTime, lType)
            } else {
              // 状态发生变化-去加载详情
              _this.stopTimeOut() //先删除
              location.reload()
            }
          }
        })
      }, timeout)
    },
    goGoogle(){
      window.open('https://www.google.cn/chrome/','_blank')
    },
    goIe() {
      window.open('https://support.microsoft.com/zh-cn/help/17621/internet-explorer-downloads','_blank')
    }
  }
}
</script>
<style lang="stylus" scoped>
$width-1200 = $container-width-1200

.i-exhibit-list{
  max-width: $width-1200;
  margin: 0 auto;
  flex-wrap :wrap;
  .i-exhibit-box{
    max-width:285px;
    width:100%;
    margin:15px 15px 15px 0;
  }
}
.i-max-width{
  width:100%;
  max-width: $width-1200;
  margin:10px auto;
}
.v-live-detail-wrap{
    width:100%;
    max-width: $width-1200;
    margin: 40px auto 25px;
    .v-live-header-Title{
      max-width 650px
      overflow hidden
      text-overflow:ellipsis
      white-space: nowrap
    }
    .v-live-header{
      line-height 18px
      font-weight: bold
    }
    .v-live-left{
        width:100%;
        max-width:1010px;
        .v-live-body{
            width:100%;
            height:520px;
            margin:16px auto
        }
        .v-live-footer{
            .v-header-img{
                width:60px;
                height:60px;
                border-radius:50%;
                overflow:hidden;
                margin:12px 0 24px;
                object-fit contain
            }
            .v-detail{
                width:100%;
                max-width:690px;
            }
        }
    }
    .v-live-right{
        text-align:right;
        .v-vertical-swiper{
            width:171px;
            height:520px;
            margin:33px 0 16px;
            overflow:hidden;
            .v-img{
                width:171px;
                height:114px;
                img{
                    width:100%;
                    height:100%;
                    object-fit: contain;
                    background-color: $color-black-10
                }
            }

            >>> .swiper-container {
                height: 100%;
            }
        }
    }
    .exchange{
      text-align right
    }

}
.v-comment-box{
  width:100%;
  max-width:1200px;
  margin:0 auto;
}
.liveTipsDialog{
  >>>.el-dialog__header{
    background $color-main 
    span, .el-dialog__close{
      color #fff
    }
  }
  .header-title{
    background $color-main 
    color #fff
  }
  .dialogConcant{
    padding 104px 120px 183px 120px
    >>> .el-button{
      margin-left 15px
    }
    p{
      line-height 20px
    }
  }
  .dialogConcantDiv{
    color $color-black-65
    font-size 14px
    margin-top 35px  
    >>> .el-input{
      width 75%
      margin-top 8px
    }
    .dialogConcantP{
      width 75%
      text-align: right;
      margin-top 8px;
      color $color-main;
      cursor:pointer
    }
  }
}
.v-browser{
  position: relative;
  bottom: auto;
  max-width: $width-1200;
  margin: 20px auto 40px;
  font-size: 14px;
  span{
    color: $color-main
    text-decoration:underline;
    cursor:pointer
  }
}
</style>
